// Shared helper: swap a button's label for an animated spinner while an async
// action is in flight. Call swapToSpinner(button) and keep the returned token;
// pass it to restoreButton(button, token) on failure so the original label
// comes back. On success, a Turbo Stream replacement typically removes the
// button entirely.

const SPINNER_SVG = `
  <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
  </svg>
`.trim()

export function swapToSpinner(button, { label = "Working" } = {}) {
  const token = {
    html: button.innerHTML,
    width: button.offsetWidth,
    ariaBusy: button.getAttribute("aria-busy"),
    ariaLabel: button.getAttribute("aria-label")
  }
  // Lock width so the button doesn't shrink when text disappears.
  button.style.minWidth = `${token.width}px`
  button.disabled = true
  button.setAttribute("aria-busy", "true")
  if (!button.getAttribute("aria-label")) {
    button.setAttribute("aria-label", label)
  }
  button.innerHTML = `<span class="inline-flex items-center justify-center gap-2" role="status" aria-label="${label}">${SPINNER_SVG}<span class="sr-only">${label}</span></span>`
  return token
}

export function restoreButton(button, token) {
  if (!token) return
  button.innerHTML = token.html
  button.disabled = false
  button.style.minWidth = ""
  if (token.ariaBusy === null) {
    button.removeAttribute("aria-busy")
  } else {
    button.setAttribute("aria-busy", token.ariaBusy)
  }
  if (token.ariaLabel === null) {
    button.removeAttribute("aria-label")
  } else {
    button.setAttribute("aria-label", token.ariaLabel)
  }
}
